import { navItems } from "../../data/siteData";
import Logo from "../ui/Logo";

function Header({ page, onNavigate }) {
  return (
    <header className="sticky top-0 z-40 border-b border-cyan-300/10 bg-[#02070d]/92 backdrop-blur">
      <div className="shell flex h-16 items-center justify-between gap-4">
        <button type="button" onClick={() => onNavigate("home")} className="text-left">
          <Logo />
        </button>

        <nav className="hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <button
              key={item.page}
              type="button"
              onClick={() => onNavigate(item.page)}
              className={`rounded-md px-3 py-2 text-sm font-semibold transition ${
                page === item.page
                  ? "bg-cyan-300 text-slate-950"
                  : "text-slate-300 hover:bg-cyan-300/10 hover:text-cyan-100"
              }`}
            >
              {item.label}
            </button>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <button type="button" onClick={() => onNavigate("admin")} className="text-sm font-semibold text-slate-400 hover:text-cyan-100">
            Prihlaseni
          </button>
          <button type="button" onClick={() => onNavigate("contact")} className="btn-primary">
            Poptat praci
          </button>
        </div>
      </div>

      <div className="shell flex gap-2 overflow-x-auto border-t border-cyan-300/10 py-2 md:hidden">
        {[...navItems, { label: "Login", page: "admin" }].map((item) => (
          <button
            key={item.page}
            type="button"
            onClick={() => onNavigate(item.page)}
            className={`shrink-0 rounded-md px-3 py-2 text-sm font-semibold ${
              page === item.page ? "bg-cyan-300 text-slate-950" : "bg-cyan-300/5 text-slate-300"
            }`}
          >
            {item.label}
          </button>
        ))}
      </div>
    </header>
  );
}

export default Header;
